__turbopack_context__.v({
  "followLink": "FollowArtistButton-module-scss-module__9aMGDa__followLink",
});
